import Vue from 'vue'
import toastr from '../toastr'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import TextInput from '../../component/dccore-form/textInput.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'

if ($('#team_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#team_form',
    components: {
      RingLoader,
      TextInput,
      Multiselect,
      Singleselect,
    },
    mixins: [mixins],
    data: {
      teamId: null,
      loading: 0,
      form: {
        entity: {
          isActive: true,
          users: [],
          type: null,
          associatedUnfoldingTeam: null,
        },
        options: {
          errors: {},
          users: [],
          type: [],
          associatedUnfoldingTeam: [],
        }
      },
    },
    computed: {
      checkAssociatedUnfoldingTeam() {
        let selected = this.form.entity.type
        if (typeof selected === 'undefined' || !selected) {
          return true
        }

        let selectedOption = this.form.options.type.find((option) => option.id === selected)
        return selectedOption.disableUnfoldingTeams
      },
    },
    mounted: function () {
      this.loading++
      this.getUsers()
      this.getTeamTypes()
      this.getUnfoldingTeams()
      if ($('#entity_id').length) {
        this.teamId = $('#entity_id').val()
        this.getTeam()
      }
      this.loading--
    },
    methods: {
      createTeam: function (redirect) {
        this.loading++
        var url = Routing.generate('api_post_team')
        if (this.checkAssociatedUnfoldingTeam) {
          this.form.entity.associatedUnfoldingTeam = null
        }
        this.$http.post(url, { data: this.form.entity }).then(() => {

          if (redirect) {
            $(location).attr('href', Routing.generate('team_grid'))
          } else {
            toastr.success(Translator.trans('team.create.created'))
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateTeam: function (redirect) {
        this.loading++
        if (this.checkAssociatedUnfoldingTeam) {
          this.form.entity.associatedUnfoldingTeam = null
        }

        var url = Routing.generate('api_patch_team', { id: this.teamId })
        this.$http.patch(url, { 'data':  this.form.entity }).then(() => {
          //this.buttonSave.button('reset');
          if (redirect) {
            $(location).attr('href', Routing.generate('team_grid'))
          } else {
            toastr.success(Translator.trans('team.update.updated'))
            this.form.options.errors = {}
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.form.options)
        })
      },
      getTeam: function () {
        var url = Routing.generate('api_get_team', {
          id: this.teamId,
          context: 'edit'
        })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.entity = response.data
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getUsers: function () {
        var url = Routing.generate('api_get_employees', { context: 'dropdown' })
        this.loading++
        this.$http.get(url).then(response => {
          this.form.options.users = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getTeamTypes: function () {
        this.loading++
        let url = Routing.generate('api_get_team_types')
        this.$http.get(url).then(response => {
          this.form.options.type = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      getUnfoldingTeams: function () {
        this.loading++
        let url = Routing.generate('api_get_active_unfolding_teams')
        this.$http.get(url).then(response => {
          this.form.options.associatedUnfoldingTeam = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
    },
  })
}
